export default __webpack_public_path__ + "static/silverMDetail-bb9de69e021fc57f0d95af29f4028d8b.png";